//!#system	

<template>
	<v-container class="timeline-dims custom-scrollbar">
		<h3 class="font-weight-light" style="padding-left: 20px;">
			Timeline
			<v-menu offset-y offset-x :close-on-content-click="false">
				<template v-slot:activator="{ on }">
					<v-btn class="float-right" small text v-on="on">
						<v-icon>more_vert</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item v-for="item in sort" :key="item.value" v-model="item.active" @click="sortTimeline(item)">
						<v-list-item-title>
							<span style="padding-right: 10px;">Sort by {{item.value}}</span>
							<v-icon v-if="item.order === 'asc'" class="iconWidth">mdi-sort-ascending</v-icon>
							<v-icon v-if="item.order === 'desc'" class="iconWidth">mdi-sort-descending</v-icon>
						</v-list-item-title>
					</v-list-item>
					<v-list-group prepend-icon="mdi-filter-outline" value="true">
						<template v-slot:activator>
							<v-list-item-title>Filter by Type</v-list-item-title>
						</template>
						<v-list-item v-for="changeType in changeTypes" :key="changeType">
							<v-checkbox v-model="filters[changeType]" @click="filterByType(changeType, $event)" :label="changeType"></v-checkbox>
						</v-list-item>
					</v-list-group>
				</v-list>
			</v-menu>
		</h3>
		<v-progress-linear
			v-if="isLoading"
			indeterminate
			color="yellow darken-2"
		>
		</v-progress-linear>
		<v-timeline v-if="isLoaded" dense clipped>
			<v-timeline-item
				fill-dot
				class="white--text mb-12"
				color="accent"
				large
			>
				<template v-slot:icon>
					<span>{{ myInitials }}</span>
				</template>
				<user-mention :chooseUser="chooseUser" ref="userMention">
					<v-textarea
						ref="timelineInput"
						v-model="input"
						auto-grow
						hide-details
						flat
						label="Leave a comment..."
						solo
						:rows=1
						@keydown.enter="userMentionCheck($event)"
						@keydown.down="userMentionFocus($event, 'down')"
						@keydown.up="userMentionFocus($event, 'up')"
						@input="userMentionListener"
					>
						<template v-slot:append>
							<v-btn
								class="mx-0"
								depressed
								@click="comment"
							>
								Post
							</v-btn>
						</template>
					</v-textarea>
				</user-mention>
			</v-timeline-item>

			<v-slide-x-transition
				group
			>
				<v-timeline-item
					v-for="(event, index) in timeline"
					:key="event.id"
					class="mb-4"
					:color="event.color"
					:small="!event.dataSet.user"
					:large="!!event.dataSet.user"
				>
					<template v-slot:icon>
						<span v-if="event.dotType === 'initials'" class="white--text" :title="event.dotType">{{ event.dataSet.user.initials }}</span>
						<v-avatar v-if="event.dotType === 'avatar'">
							<application-file-view :servePath="event.dataSet.user.avatar.servePath" :avatar="true" :size="40" />
						</v-avatar>
						<v-icon v-if="event.icon" dark small :title="event.dotType" :key="event.id + '_icon'">{{ event.icon }}</v-icon>
					</template>

					<v-layout justify-space-between>
						<v-flex xs12>
							<div v-if="event.dataSet.user" class="caption">
								By <span class="font-weight-bold">{{event.dataSet.user.name}}</span>&nbsp;<data-string class="caption" :value="event.createdAt" :cannotBeInFuture="true" />
							</div>
							<div :class="'markdown-html' + (event.truncated ? ' clipped' : '')" v-html="event.text" @click="handleUserMention"></div>
							<div>
								<span v-if="event.truncated" class="float-right">
									<v-btn x-small @click="toggleViewAll(event)">Expand</v-btn>
								</span>
								<span v-if="event.changeType === 'Auto-Note'">
									<v-chip x-small>Auto-Note</v-chip>
								</span>
							</div>
						</v-flex>
					</v-layout>
					<div v-if="index >= 999" style="font-size: 10px;margin-top: 20px;">
						Only the last 1,000 entries are shown.
					</div>
				</v-timeline-item>
			</v-slide-x-transition>

		</v-timeline>
		<v-dialog v-model="viewAll">
			<v-card>
				<div class="view-all-card" v-html="viewAllText"></div>
			</v-card>
		</v-dialog>
		<v-snackbar
			v-model="noteError"
		>
			{{ noteError }}
			<v-btn
				text
				@click="noteError = null"
			>
				Close
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
	import store from '@/store';
	import apiService from '@/apiService';
	import tools from '@/tools';
	import DataString from '@/components/pieces/DataString';
	import ApplicationFileView from '@/components/pieces/ApplicationFileView';
	import UserMention from '@/components/pieces/UserMention';

	export default {
		props: ['routeInfo'],
		components: {
			DataString,
			ApplicationFileView,
			UserMention
		},
		data: () => ({
			isLoading: false,
			isLoaded: false,
			errorState: false,
			viewAll: false,
			viewAllText: '',
			events: [],
			allEvents: [], // Unfiltered list of events
			input: null,
			nonce: 0,
			noteError: null,
			fetchedData: false,
			myInitials: store.state.authentication.user.initials,
			userMentionValue: null,
			usersMentionedUserData: {}, // Store user data of users that were mentioned to avoid multiple calls. Key is `username`.
			changeTypes: [],
			filters: {},
			sort: [{
				value: 'Type',
				active: false,
				order: null
			}, {
				value: 'Time',
				active: true,
				order: 'desc'
			}]
		}),

		computed: {
			timeline () {
				return this.events.slice().reverse()
			},
		},

		created() {
			if (!this.fetchedData && !this.isLoading) {
				this.getHistory();
			}
		},

		activated() {
			if (!this.fetchedData && !this.isLoading) {
				this.getHistory();
			}
		},

		methods: {
			reload() {
				this.getHistory();
			},
			toggleViewAll(event) {
				this.viewAll = !this.viewAll;
				this.viewAllText = event.text;
			},
			getHistory() {
				let hasFilter = false;

				this.isLoading = true;
				apiService.history(this.$props.routeInfo, (err, history) => {
					this.fetchedData = true;
					this.isLoading = false;
					if (!this.isLoaded) this.isLoaded = true;
					if (err) {
						this.errorState = true;
						this.$store.dispatch('app/applyObjectError', {
							show: true,
							text: meta.validation ? meta.validation.messages.join('\n') : err 
						});
						return;
					}
					history.forEach(historyItem => {
						historyItem.dotType = 'avatar';
						historyItem.color = 'primary';
						historyItem.icon = '';
						if (historyItem.changeType === 'Creation') {
							historyItem.dotType = 'created';
							historyItem.icon = 'mdi-plus-box';
						}
						if (historyItem.changeType === 'Error') {
							historyItem.dotType = 'error';
							historyItem.color = 'error';
							historyItem.icon = 'mdi-exclamation';
						}
						if (historyItem.changeType === 'Change') {
							historyItem.dotType = 'change';
							historyItem.color = 'accent';
							historyItem.icon = 'mdi-square-edit-outline';
						}
						if (historyItem.changeType === 'Automated-Action') {
							historyItem.dotType = 'automated';
							historyItem.color = 'accent';
							historyItem.icon = 'mdi-robot';
						}
						if (historyItem.dotType === 'avatar' && (!historyItem.dataSet.user.avatar || !historyItem.dataSet.user.avatar.servePath)) {
							historyItem.dotType = 'initials';
						}
						if (historyItem.changeType === 'Note') {
							historyItem.text = tools.template('history-' + historyItem.stringTemplateType + '-' + historyItem.id, tools.escapeHTML(historyItem.dataSet.note), historyItem.dataSet);
						} else {
							historyItem.text = tools.template('history-' + historyItem.stringTemplateType, historyItem.template, historyItem.dataSet);
						}
						historyItem.truncated = this.shouldByTruncatedView(historyItem.text);
						historyItem.timeClass = historyItem.truncated ? 'overline' : 'overline history-time';

						if (!this.changeTypes.includes(historyItem.changeType)) {
							this.changeTypes.push(historyItem.changeType);
						}
					});

					this.allEvents = history;

					// This rest of this code is to determine if we need to apply the filters/sort
					for (let filter in this.filters) {
						if (this.filters[filter]) {
							hasFilter = true;
							break;
						}
					}

					if (hasFilter) {
						this.events = this.allEvents.filter(event => {
							return this.filters[event.changeType];
						});
					} else {
						this.events = this.allEvents;
					}

					this.sort.map(sortItem => {
						if (sortItem.active) {
							this.doSort(sortItem);
						}
					});
				});
			},

			shouldByTruncatedView(stringBlock) {
				const mtc = stringBlock.match(/\n/g);
				if (!stringBlock || !mtc) return false;
				return mtc.length > 5;
			},

			filterByType(changeType, e) {
				e.stopPropagation();
				e.preventDefault();

				this.events = this.allEvents.filter(event => {
					return this.filters[event.changeType];
				});

				// No events means no filters applied
				if (this.events.length === 0) {
					this.events = this.allEvents;
				}

				this.sort.map(sortItem => {
					if (sortItem.active) {
						this.doSort(sortItem);
					}
				});
			},

			// This order of the array and the way it's shown in timeline is reversed.
			// The first element in the array appears at the bottom because it's rendered first.
			doSort(item) {
				if (item.value === 'Type') {
					this.events.sort((a, b) => {
						return this.sortCompare(a.changeType.toLowerCase(), b.changeType.toLowerCase(), item.order);
					});
				} else if (item.value === 'Time') {
					this.events.sort((a, b) => {
						return this.sortCompare(new Date(a.createdAt), new Date(b.createdAt), item.order);
					});
				}
			},

			// This is the click event
			sortTimeline(item) {
				if (!item.order || item.order === 'desc') {
					item.order = 'asc';
				} else if (item.order === 'asc') {
					item.order = 'desc';
				}
				item.active = true;

				this.sort.map(sortItem => {
					if (sortItem.value !== item.value) {
						sortItem.order = null;
						sortItem.active = false;
					}
				});

				this.doSort(item);
			},

			sortCompare(a, b, order) {
				let comparison = 0;

				if (a > b) {
					comparison = 1;
				} else if (a < b) {
					comparison = -1;
				}

				return comparison * (order === 'asc' ? -1 : 1);
			},

			comment (e) {
				if (typeof this.input !== 'string') this.input = '';
				this.input = this.input.trim();
				if (!this.input) return;

				const dataSet = {
					user: this.$store.state.authentication.user,
					note: this.input
				};
				const text = tools.disposableTemplate(tools.escapeHTML(dataSet.note), dataSet);
				const usersMentioned = []; // Unique set of usernames (in case they were mentioned multiple times)

				this.nonce++;
				this.events.push({
					id: this.nonce,
					text: text,
					dotType: dataSet.user.avatar && dataSet.user.avatar.servePath ? 'avatar' : 'initials',
					icon: '',
					color: 'primary',
					dataSet: dataSet,
					createdAt: (new Date()).toISOString(),
					timeClass: 'overline'
				});

				apiService.note({ ...this.$props.routeInfo, note: this.input }, err => {
					if (err) this.noteError = err.message;

					tools.userMentionsGetUsers(dataSet.note).map(userMentionString => {
						const username = userMentionString.split('@')[1];

						if (usersMentioned.includes(username)) return;

						usersMentioned.push(username);

						apiService.call({
							method: 'post',
							path: '/uac/users/action/send-user-mention-email/' + encodeURIComponent(this.usersMentionedUserData[username].id),
							body: {
								pageUrl: window.location.href,
								content: text
							}
						}, (err, response) => {
							if (err) this.noteError = err.message;
						});
					});
				});

				this.input = null
			},

			userMentionCheck(e) {
				let userList;
				try {
					userList = this.$refs.userMention.$refs.userMentionMenu.$refs.content.querySelector('.v-list');
				} catch(err) {
					console.log(err);
				}

				// If the user hits "Enter" and the user mentions search is open, it should select the first one
				if (userList && userList.childNodes.length) {
					// To stop the "Enter" key from adding a new line
					e.preventDefault();
					e.stopPropagation();
					userList.firstChild.click();
				}
			},

			userMentionListener() {
				clearTimeout(this.searchUsersTimeout);

				if (!this.input) {
					// Reset everything
					this.$refs.userMention.reset();
					this.userMentionValue = null;
					return;
				}

				const splitValues = this.input.split('@');

				let prevWord, lastChar, userMentionValue;

				if (splitValues.length > 1) {
					prevWord = splitValues[splitValues.length - 2];

					// Allow user mention searching if the `@` key is
					// 1. At the beginning of input (prevWord === '')
					// 2. There's a space between `@` and the previous word
					// 3. There's a new line between `@` and the previous word
					if (prevWord === '' || prevWord.endsWith(' ') || prevWord.match(/\n/g)) {
						userMentionValue = splitValues[splitValues.length - 1];

						if (userMentionValue && userMentionValue.match(/\W/)) {
							// Anything that's not alphanumeric removes/resets the search
							this.$refs.userMention.reset();
							this.userMentionValue = null;
						} else if (userMentionValue) {
							this.searchUsersTimeout = setTimeout(() => {
								this.userMentionValue = userMentionValue;
								this.$refs.userMention.searchUsers(userMentionValue);
							}, 500);
						} else {
							this.$refs.userMention.reset();
							this.userMentionValue = null;
						}
					}
				} else {
					this.$refs.userMention.reset();
					this.userMentionValue = null;
				}
			},

			userMentionFocus(e, direction) {
				const userList = this.$refs.userMention.$refs.userMentionMenu.$refs.content.querySelector('.v-list');
				let elementToFocus;

				if (!userList || !userList.childNodes.length) return;

				e.preventDefault();
				e.stopPropagation();

				if (direction === 'down') {
					elementToFocus = userList.firstChild;
				} else {
					elementToFocus = userList.lastChild;
				}
				
				elementToFocus.focus();
			},

			chooseUser(user) {
				this.input = this.input.replace('@' + this.userMentionValue, '@' + user.username);
				this.usersMentionedUserData[user.username] = user;
				this.$refs.timelineInput.focus();
				this.$refs.userMention.reset();
				this.userMentionValue = null;
			},

			handleUserMention(e) {
				if (e.target && e.target.className.includes('user-mention')) {
					const username = e.target.innerText;

					if (this.usersMentionedUserData[username]) {
						tools.goToDetail(this.routeInfo, this.usersMentionedUserData[username].id);
					} else {
						apiService.list({ namespace: 'uac', pluralName: 'users', filters: {
							username: { operator: 'cn', value: username }
						} }, (err, response, meta) => {
							if (err) {
								this.noteError = err.message;
							}

							if (response && response.length) {
								tools.goToDetail(this.routeInfo, response[0].id);
							}
						});
					}
				}
			}
		}
	}
</script>

<style scoped>
.history-time {
	margin-top: -10px;
}
.timeline-dims {
	max-height: 800px;
	overflow-y: auto;
}
.clipped {
	max-height: 140px;
	overflow: hidden;
}
.view-all-card {
	padding:30px;
}
</style>